import React from 'react'
import { SynthesisReviewType } from './synthesisReview'
import { DialogType } from '../../../../../../control/dialog/dialog'
import checkPermission from '../../../../../../utilities/checkPermission'
import useWebService from '../../../../../../services/web/useWebService'
import useLoading from '../../../../../../control/loading/useLoading'
import authenStore from '../../../../../../stores/authen/authenStore'
import { TabSelectedType } from '../../../../../../stores/appFolderAndTab/appFolderAndTabStore'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import useTranslate from '../../../../../../i18n/useTranslate'
import { SynthesisReviewProjectRequestType } from '../../../../../../services/web/types/requestWebServiceTypes'
import useFolderAndTab from '../../../useFolderAndTab'
import { TFormValue } from '../synthesisReviewType'
import { useHistory } from 'react-router-dom'
import { RoutePath } from '../../../../../../router/routesConfig'
import _ from 'lodash'
import { SynthesisReviewRemarkInfo } from '../../../../../../services/web/types/responseWebServiceTypes'
import submittedStep from '../../../../../../constants/submittedStep'

const useSynthesisReview = (props: SynthesisReviewType) => {
    const { projectData, onSaveComplete } = props
    const [initialValues, setInitialValues] = React.useState<any>({})
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const checkPermissionHook = checkPermission()
    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const isShowUpdateDate = checkPermissionHook.chkShowUpdateDate(projectData)
    const callWebService = useWebService()
    const loadingHook = useLoading()
    const { profile } = authenStore()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const translate = useTranslate()
    const tabAndFolderHook = useFolderAndTab()
    const history = useHistory()
    const formValues = React.useRef<TFormValue>()
    const [isLoadedSynthesisReview, setIsLoadedSynthesisReview] = React.useState<boolean>(false)
    const [synthesisReviewRemarkInfoList, setSynthesisReviewRemarkInfo] = React.useState<SynthesisReviewRemarkInfo>()
    const [initialRichTextEditor, setInitialRichTextEditor] = React.useState<any>()
    const formRef = React.useRef<any>()

    React.useEffect(() => {
        getSynthesisReviewData()
    }, [projectData?.submittedID ?? null])

    React.useEffect(() => {
        createInitialData()
        createInitialRichTextEditor()
    }, [isLoadedSynthesisReview])

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    const getSynthesisReviewData = async () => {
        if (projectData) {
            setIsLoadedSynthesisReview(false)
            loadingHook.loadingOpen()
            const submittedID = projectData.submittedID
            const data = await callWebService.getSynthesisReview(submittedID)
            loadingHook.loadingClose()
            if (data.status === 1) {
                setSynthesisReviewRemarkInfo(data.result.synthesisReviewRemarkInfo)
                setIsLoadedSynthesisReview(true)
            }
        }
    }

    /**
     * Default value form
     */
    const createInitialData = async () => {
        if (synthesisReviewRemarkInfoList) {
            const initialData = {
                synthesisList: synthesisReviewRemarkInfoList?.synthesisRemark
                    ? synthesisReviewRemarkInfoList?.synthesisRemark
                    : '-',
            }
            setInitialValues(initialData)
        }
    }

    const createInitialRichTextEditor = () => {
        if (synthesisReviewRemarkInfoList) {
            const initialData = {
                contentHtml: synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark_html
                    : synthesisReviewRemarkInfoList?.synthesisRemark,
                contentText: synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    ? synthesisReviewRemarkInfoList?.synthesisReviewRemark
                    : synthesisReviewRemarkInfoList?.synthesisRemark,
            }

            setInitialRichTextEditor(initialData)
        }
    }

    /**
     * process save
     */
    const handleSubmitForm = async (val: TFormValue) => {
        const parameter = getParameterForSave(val)

        if (val.submitType === 'save') {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.NOTIFICATION'),
                content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    handleConfirmSave(parameter)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            //ถ้า save draft ไม่ต้องมี alert confirm
            handleConfirmSave(parameter)
        }
    }
    const getParameterForSave = (val: TFormValue) => {
        let paramForSave = null
        const submittedID = projectData?.submittedID ?? null

        let isDraft = false
        if (val.submitType === 'draft') {
            isDraft = true
        }

        const synthesisReviewProjectRequest: SynthesisReviewProjectRequestType = {
            loginUserID: profile.userId,
            submittedID: submittedID,
            synthesisReviewInfo: null,
            stampFileList: null,
            synthesisReviewRemarkInfo: {
                remark: val.consideration && val.consideration.contenText ? val.consideration.contenText : null,
                remark_htmltag:
                    val.consideration && val.consideration.contentHtml ? val.consideration.contentHtml : null,
            },
            isDraft: isDraft,
        }
        paramForSave = synthesisReviewProjectRequest
        return paramForSave
    }

    const handleConfirmSave = async (
        paramForSave: SynthesisReviewProjectRequestType,
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        const isDraft = paramForSave.isDraft ? paramForSave.isDraft : false
        const isAutoSave = !!(paramForSave as any)?.isAutoSave
        loadingHook.loadingOpen()

        const param = { ...paramForSave } as SynthesisReviewProjectRequestType
        const res = await callWebService.synthesisReviewTerminatedProject(param)
        dialogRef.current?.closeDialog()

        if (!isFolder) {
            //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน folder ใช่หรือไม่?
            if (tabIndex && newTabSelected) {
                //if นี้จะเช็คว่าเป็นการติด dirty จากการกดเปลี่ยน Tab ใช่หรือไม่?
                tabAndFolderHook.setTab(tabIndex, newTabSelected)
            } else {
                //หากเข้า else หมายความว่าเป็นการบันทึกจากกดปุ่มบันทึกไม่ใช่จากการติด dirty
                if (onSaveComplete && !isAutoSave) {
                    if (res && res.status) {
                        onSaveComplete(res.status, isDraft)
                    }
                }
            }
        }

        loadingHook.loadingClose()
    }

    const handleAutoSave = async (values: TFormValue) => {
        try {
            const isPassedSynthesisReview = (projectData?.stepID ?? 0) > submittedStep.synthesisReview
            if (isPassedSynthesisReview) return

            const paramForSave = getParameterForSave({ ...values, submitType: 'draft' })
            const reviewRemark = paramForSave.synthesisReviewRemarkInfo
            if (!reviewRemark?.remark?.trim() && !reviewRemark?.remark_htmltag?.trim()) return
            ;(paramForSave as any).isAutoSave = true
            await callWebService.synthesisReviewTerminatedProject(paramForSave as SynthesisReviewProjectRequestType)
        } catch (error) {
            console.error(error)
        }
    }

    const handleClickBackToSearch = (dirty: boolean) => {
        if (dirty) {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.WARNING'),
                content: translate.get('ALERT.CONTENT.NEED_TO_CANCEL'),
                type: 'alert-confirm',
                onClickConfirm: () => {
                    history.push(RoutePath.manageProject)
                },
            })
            dialogRef.current?.openDialog()
        } else {
            history.push(RoutePath.manageProject)
        }
    }

    /**
     * Dirty
     */

    const handleDirtyChange = (props: any) => {
        formValues.current = { ...props.values }

        let isDirty: boolean = false
        const consideration = {
            contentHtml: initialRichTextEditor?.contentHtml,
            contentText: initialRichTextEditor?.contentText,
        }
        const initialVal = {
            ...initialValues,
            consideration: consideration,
        }
        //** จัดformat initValue และ Form Value เพื่อเตรียมตัวนำไปใช้เปรียบเทียบค่า  **//
        let newFormValue = _.omit(props.values, ['submitType'])

        let initValue = _.omit(initialVal, ['submitType'])

        //**********************************************************//
        const isEqual = _.isEqual(initValue, newFormValue) //ข้อมูลเท่ากัน

        if (!isViewMode) {
            if (isEqual) {
                isDirty = false
            } else {
                isDirty = true
            }
        }

        const paramsDirty = {
            tabDirty: isDirty,
            callbackDirty: callbackDirtyProcess,
        }
        appFolderAndTabAction.setDirty(paramsDirty)
    }

    const callbackDirtyProcess = (
        tabIndex: number | null = null,
        newTabSelected: TabSelectedType | null = null,
        isFolder?: boolean,
    ) => {
        const parameter = getParameterForSave(formValues.current)
        if (parameter) {
            parameter.isDraft = true
            handleConfirmSave(parameter, tabIndex, newTabSelected, isFolder)
        }
    }
    return {
        formRef,
        isViewMode,
        configDialog,
        initialValues,
        isShowUpdateDate,
        initialRichTextEditor,
        onRefDialog,
        onSubmitForm: handleSubmitForm,
        onClickBackToSearch: handleClickBackToSearch,
        onDirtyChange: handleDirtyChange,
        onAutoSave: handleAutoSave,
    }
}
export default useSynthesisReview
